export const CONSTANTS = Object.freeze({
  APP_PTD_SITE_URL: 'https://www.propertytaxdetective.com',
  // APP_DEFAULT_IMG: require('@/assets/img/src/img-box-default.jpg'),

  // APP_YOUTUBE_PROFILE_URI: 'https://www.youtube.com/channel/UCHK9JdZIShJKFuvG3WYPbWw',
  // APP_FACEBOOK_PROFILE_URI: 'http://facebook.com/taxappeals',
  // APP_TWITTER_PROFILE_URI: 'https://twitter.com/ptdcorp',

  APP_URL_PARAMS: {
    //---general
    type: null,
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    affiliateCode: null
  },
});